import { fetchPoll, pollResultsShow } from 'src/modules/community/poll/actions';
import { fetchCurrentCommunity } from 'src/modules/shared/context/actions';
import { fetchCommunityAbout } from 'src/modules/community/communityAbout/actions';
import { fetchPinnedPosts } from 'src/modules/community/singlePost/actions/fetchActions';

import WithErrorHandling, { RequestError } from 'src/components/hoc/withErrorHandling';
import PollPage from 'src/modules/community/poll/pollPage';
import { PageContext } from 'src/constants/types';

const Page = () => <PollPage />;

Page.getInitialProps = async ({ store: { dispatch, getState }, query: { communitySlug, id, result } }: PageContext) => {

  await dispatch(fetchCurrentCommunity(communitySlug));

  const { currentCommunity, communityErrorStatusCode, currentUser } = getState().context;

  if (communityErrorStatusCode || !currentCommunity) {
    const isHiddenPrivateCommunity = communityErrorStatusCode === 310;
    if (isHiddenPrivateCommunity) {
      if (!currentUser) throw new RequestError('This page is not available to visitors', 401);
      throw new RequestError('This is a private community', 404); // user is not a member
    }
    throw new RequestError('Error fetching community', communityErrorStatusCode);
  }

  await Promise.all([
    dispatch(fetchPoll(id, communitySlug)),
    dispatch(fetchCommunityAbout(communitySlug)),
  ]);

  const { pages: { singlePost: { post, postError } } } = getState();

  if (postError || !post) {
    throw new RequestError('Error fetching poll', postError.status);
  }

  if (currentUser) {
    await dispatch(fetchPinnedPosts(communitySlug));
  }

  if (result === 'result') {
    await dispatch(pollResultsShow());
  }

  return {};
};

export default WithErrorHandling(Page);
